import React from "react";
import Modal from "react-bootstrap/Modal";
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MaskedInput from "react-input-mask";

import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from "@material-ui/core/styles";

import CloseIcon from "@material-ui/icons/Close";

import {
  ModalContent,
  Filters,
  ButtonDays,
  Period,
  ButtonFilter,
  Datefield,
} from "./styles";
import iconfilter from "~/assets/images/filter_icon.svg";
import { Types } from "~/pages/GasVoucherList";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 300,
            fontSize: '1.1rem'
        },
    },
};

const useStyles = makeStyles({
  root: {
      background: 'white',
      border: '1px solid #b0b0b0',
      borderRadius: '0.3rem',
      color: '#8c8c8c',
      boxShadow: '0px 3px 6px #00000066',
      width: '100%'
  },
});

export default function ModalFilter({
  activeModal,
  activebeginDate,
  activeEndDate,
  changeFilter,
  changeFilterDate,
  showModal,
  beginDateFilter,
  endDateFilter,
  loadingPage,
  filterMonth,
  setFilterMonth,
  selectMonth,
}) {
  const classes = useStyles()

  return (
    <Modal
      show={showModal}
      onHide={() => {
        activeModal();
      }}
      className="modal-vale-gas"
      centered={window.screen.width >= 768}
    >
      <Modal.Body style={{ padding: ".5rem", borderRadius: 15 }}>
        <ModalContent>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Filters
              style={{
                color: "#000FFF",
                fontSize: 18,
                fontWeight: "bold",
              }}
            >
              Filtros
            </Filters>
            <CloseIcon
              style={{ color: "#000FFF", cursor: "pointer" }}
              onClick={() => activeModal()}
            />
          </div>

          <div style={{ padding: 10 }}>
            <Period>Período:</Period>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <ButtonDays onClick={() => changeFilter(Types.DAYS_15)}>
                Últimos 15 dias
              </ButtonDays>
              <ButtonDays onClick={() => changeFilter(Types.DAYS_30)}>
                Últimos 30 dias
              </ButtonDays>
            </div>
            <div
              style={{
                marginTop: 16,
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <ButtonDays onClick={() => changeFilter(Types.DAYS_1)}>
                Diário
              </ButtonDays>
              <ButtonDays onClick={() => changeFilter(Types.DAYS_7)}>
                Semanal
              </ButtonDays>
            </div>

            <hr />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <Period>Data Inicial:</Period>
                <Datefield
                  onChange={async (event) =>
                    await activebeginDate(event.target.value)
                  }
                  value={beginDateFilter}
                  placeholder="--/--/----"
                  as={MaskedInput}
                  mask="99/99/9999"
                >
                  {(props) => {
                    const {
                      type,
                      name,
                      id,
                      placeholder,
                      value,
                      mask,
                      ...inputProps
                    } = props;
                    return (
                      <input
                        type={type}
                        name={name}
                        id={id}
                        placeholder={placeholder}
                        value={value}
                        {...inputProps}
                      />
                    );
                  }}
                </Datefield>
              </div>

              <div style={{ paddingLeft: ".7rem" }}>
                <Period>Data Final:</Period>
                <Datefield
                  as={MaskedInput}
                  onChange={async (event) =>
                    await activeEndDate(event.target.value)
                  }
                  value={endDateFilter}
                  placeholder="--/--/----"
                  mask="99/99/9999"
                >
                  {(props) => {
                    const {
                      type,
                      name,
                      id,
                      placeholder,
                      value,
                      mask,
                      ...inputProps
                    } = props;
                    return (
                      <input
                        type={type}
                        name={name}
                        id={id}
                        placeholder={placeholder}
                        value={value}
                        {...inputProps}
                      />
                    );
                  }}
                </Datefield>
              </div>
            </div>

            <ButtonFilter onClick={() => changeFilterDate()}>
              <img
                src={iconfilter}
                alt="Ícone de filtrar"
                style={{ margin: "0 -1.5rem 0 .8rem" }}
              />
              <span style={{ textAlign: "center", width: "100%" }}>
                {loadingPage ? (
                  <i className="fa fa-spinner fa-pulse fa-3x fa-fw" style={{ fontSize: "1rem" }} />
                ) : (
                  "Filtrar"
                )}
              </span>
            </ButtonFilter>
          </div>
        </ModalContent>
      </Modal.Body>
    </Modal>
  );
}
